import React, { useState, useEffect } from 'react';
import { newsAPI } from '../services/api';

const News = () => {
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    loadNews();
    const checkMobile = () => setIsMobile(window.innerWidth <= 768);
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const loadNews = async () => {
    try {
      const response = await newsAPI.getAll();
      setNews(response.data);
      setLoading(false);
    } catch (error) {
      console.error('Error loading news:', error);
      setLoading(false);
    }
  };

  if (loading) return <div style={styles.loading}>Cargando...</div>;

  return (
    <section style={isMobile ? {...styles.section, ...styles.sectionMobile} : styles.section}>
      <div style={styles.container}>
        <h2 style={isMobile ? {...styles.title, ...styles.titleMobile} : styles.title}>NEWS</h2>
        
        <div style={isMobile ? {...styles.grid, ...styles.gridMobile} : styles.grid}>
          {news.map(item => (
            <div key={item.id} style={styles.newsCard}>
              {item.imageUrl && (
                <div style={styles.imageContainer}>
                  <img 
                    src={item.imageUrl} 
                    alt={item.title} 
                    style={styles.newsImage}
                    onError={(e) => {
                      console.error('❌ Error loading image:', item.imageUrl);
                      e.target.style.display = 'none';
                    }}
                  />
                </div>
              )}
              
              <div style={isMobile ? {...styles.newsContent, ...styles.newsContentMobile} : styles.newsContent}>
                <h3 style={isMobile ? {...styles.newsTitle, ...styles.newsTitleMobile} : styles.newsTitle}>
                  {item.title}
                </h3>
                <p style={styles.newsText}>{item.content}</p>
                {item.instagramLink && (
                  <a 
                    href={item.instagramLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={isMobile ? {...styles.instagramLink, ...styles.instagramLinkMobile} : styles.instagramLink}
                  >
                    View on Instagram
                  </a>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

const styles = {
  section: {
    minHeight: '100vh',
    background: 'linear-gradient(180deg, #1a1a1a 0%, #000 100%)',
    padding: '100px 2rem 4rem',
    fontFamily: 'Roboto, sans-serif',
  },
  sectionMobile: {
    padding: '80px 1rem 2rem',
  },
  container: {
    maxWidth: '1400px',
    margin: '0 auto',
    fontFamily: 'Roboto, sans-serif',
  },
  title: {
    fontSize: '3rem',
    color: '#fff',
    letterSpacing: '0.3rem',
    marginBottom: '3rem',
    fontFamily: 'Roboto, sans-serif',
  },
  titleMobile: {
    fontSize: '2rem',
    letterSpacing: '0.15rem',
    marginBottom: '2rem',
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
    gap: '2rem',
    maxWidth: '100%',
    fontFamily: 'Roboto, sans-serif',
  },
  gridMobile: {
    gridTemplateColumns: '1fr',
    gap: '1.5rem',
  },
  newsCard: {
    background: '#1a1a1a',
    borderRadius: '10px',
    overflow: 'hidden',
    transition: 'transform 0.3s',
    width: '100%',
    fontFamily: 'Roboto, sans-serif',
  },
  imageContainer: {
    width: '100%',
    overflow: 'hidden',
    background: '#222',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontFamily: 'Roboto, sans-serif',
  },
  newsImage: {
    width: '100%',
    height: 'auto',
    display: 'block',
    objectFit: 'contain',
    fontFamily: 'Roboto, sans-serif',
  },
  newsContent: {
    padding: '1.5rem',
    fontFamily: 'Roboto, sans-serif',
  },
  newsContentMobile: {
    padding: '1rem',
  },
  newsTitle: {
    fontSize: '1.3rem',
    color: '#fff',
    marginBottom: '0.8rem',
    fontFamily: 'Roboto, sans-serif',
  },
  newsTitleMobile: {
    fontSize: '1.1rem',
  },
  newsText: {
    color: '#ccc',
    lineHeight: '1.6',
    marginBottom: '1.2rem',
    fontSize: '0.95rem',
    fontFamily: 'Roboto, sans-serif',
  },
  instagramLink: {
    display: 'inline-block',
    padding: '0.6rem 1.5rem',
    background: 'linear-gradient(45deg, #833ab4,rgb(110, 66, 168),rgb(105, 70, 112))',
    color: 'white',
    textDecoration: 'none',
    borderRadius: '25px',
    transition: 'transform 0.3s',
    fontSize: '0.9rem',
    fontFamily: 'Roboto, sans-serif',
  },
  instagramLinkMobile: {
    padding: '0.5rem 1.2rem',
    fontSize: '0.85rem',
  },
  loading: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#fff',
    fontSize: '1.5rem',
    fontFamily: 'Roboto, sans-serif',
  },
};

export default News;
